<button mat-icon-button [disabled]="zoningCode.isDeleting || zoningCode.isOrphan"
    [class.not-clickable-actions-buttons]="zoningCode.isDeleting" class="actions-buttons">
    <mat-icon matTooltip="Check version" (click)="checkVersion($event, zoningCode)" class="actions-mat-icons">
        restore</mat-icon>
</button>